import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Header {
    constructor(){
        this.header = {
            el: document.querySelector('header'),
            content: document.querySelectorAll('header nav'),
        };

        this.footer = document.querySelector('footer');

        this.company = document.getElementById('company');
    }

    init(){
        if(Sniff.features.mobile){
            // this.set();
            // this.animation();
        }
    }

    set = () => {
        gsap.set(this.company, {
            autoAlpha: 0,
        });
    }

    animation = () => {
        gsap.to(this.company, 1,{
            autoAlpha: 1,
            delay: .25,
            ease: 'expo.easeInOut',
            scrollTrigger: {
                trigger: this.footer,
                start: 'bottom-=20 bottom',
                toggleActions: 'play none play reverse',
            }
        });
    }
}
